// src/pages/SearchScreen.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useApp } from '../lib/AppContext';

export default function SearchScreen() {
  const { lang, searchQuery, fmt, addToCart } = useApp();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!searchQuery || searchQuery.length < 2) { setResults([]); return; }
    setLoading(true);
    const timer = setTimeout(async () => {
      const { data } = await supabase
        .from('products')
        .select('*, category:categories(name, icon)')
        .eq('active', true)
        .or(`name->>en.ilike.%${searchQuery}%,sku.ilike.%${searchQuery}%`);
      setResults(data || []);
      setLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  return (
    <div className="page-container" style={{ padding:'32px 24px' }}>
      {!searchQuery && (
        <div style={{ textAlign:'center', padding:'6rem 0', color:'#555' }}>
          <div style={{ fontSize:'3rem', marginBottom:12, opacity:.2 }}>🔍</div>
          <p style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.9rem', letterSpacing:'.1em', textTransform:'uppercase' }}>Start typing to search</p>
        </div>
      )}
      {loading && <div style={{ textAlign:'center', padding:'3rem' }}><div className="spinner" style={{ margin:'0 auto' }} /></div>}
      {!loading && searchQuery && results.length === 0 && (
        <div style={{ textAlign:'center', padding:'6rem 0', color:'#555' }}>
          <p style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.9rem', letterSpacing:'.1em', textTransform:'uppercase' }}>No results for "{searchQuery}"</p>
        </div>
      )}
      {results.length > 0 && (
        <>
          <p style={{ color:'#555', fontSize:'.85rem', marginBottom:16 }}>{results.length} result{results.length!==1?'s':''} for "{searchQuery}"</p>
          <div className="prod-grid">
            {results.map(p => (
              <div key={p.id} className="prod-card" onClick={() => navigate(`/product/${p.id}`)}>
                <div className="prod-card-img">
                  {p.images?.[0]
                    ? <img src={p.images[0]} alt={p.name?.[lang] || p.name?.en} loading="lazy" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                    : <span style={{ opacity:.2 }}>🌿</span>
                  }
                </div>
                <div className="prod-card-body">
                  <div className="prod-card-cat">{p.category?.name?.[lang] || p.category?.name?.en}</div>
                  <div className="prod-card-name">{p.name?.[lang] || p.name?.en}</div>
                  <div className="prod-card-foot">
                    <span className="prod-price">{fmt(p.price_eur)}</span>
                    <button className="prod-add-btn" onClick={e => { e.stopPropagation(); addToCart(p); }}>+</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}